module.exports = __webpack_public_path__ + "img/menu3_hover.59a63a99.png";